import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-jointworkingcall',
  template: require('./jointworkingcall.component.html'),
  styles: []
})
export class JointWorkingCallComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  api: any;
  busy: Subscription;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;

  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;


  static parameters = [ApiService]

  constructor(
    private apiService: ApiService

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      { headerName: 'Manager', field: "Manager" },
      { headerName: 'Head Qtr', field: "hdqtr" },
      { headerName: 'Employee', field: "Employee" },
      { headerName: 'Staff Type', field: "StaffType" },
      { headerName: 'Call Date', field: "CallDate" },
      { headerName: 'Month', field: "Month" },
      { headerName: 'JW With', field: "JWWith" },
      { headerName: 'Route', field: "Route" },
      { headerName: 'DA Type', field: "DAType" },
      { headerName: 'DR Call', field: "DRCall" },
      { headerName: 'Chemist Call', field: "ChemistCall" },
      { headerName: 'Remark', field: "Remark" },
    ];
    this.defaultColDefine = { resizable: true };
    this.rowData = [
      { sno: '1', Manager: 'Biplov Kumar Singh', hdqtr: 'West Delhi', Employee: 'Atul Kumar Sexena', StaffType: 'ASM', CallDate: '01/02/2021', Month: 'March-2021', JWWith: 'Amarpal Singh', Route: "Noida to Tilak Nagar", DAType: "L", DRCall: "0", ChemistCall: "21", Remark: "Imperial Surgical" }
    ];
    this.rowHeight = 50;
  }

  onFirstDataRendered(params) {
    setTimeout(function () {
      params.api.getDisplayedRowAtIndex(1).setExpanded(false);
    }, 0);
  }

  ngOnInit() {
    this.getStaffTypes();
    // this.getExpDetails();
    var date = new Date();
    this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
    this.currentMonth = this.currentDate;
    console.log('currentDate', this.currentMonth);
  }

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();

  }

  onBtnExport() {
    this.api.exportDataAsCsv({ fileName: 'ExpenseDetail' });
  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }

  sizeToFit(skipHeader) {
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  getStaffTypes() {
    this.apiService.getStaffTypes().subscribe((res: any) => {
      this.staffTypes = res.data;
      console.log('stafftypes ', this.staffTypes);
    })
  }

  getExpDetails() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
        //  console.log('token', token);
        var data = {
            Id: token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.expDetails = res.data;
      console.log('empDetails', this.expDetails);
    })
  }

  filterData() {
    // console.log('staffs ', this.staff, this.designation, this.currentMonth);
    var queryData = {
      staffId: this.staff ? this.staff.ClientTypeID : '',
      designationId: this.designation ? this.designation.ClientTypeID : '',
      date: this.currentMonth
    }
    console.log('filterdata get expense stmt', queryData);
    this.apiService.getExpenseStmt(queryData).subscribe((res: any) => {
      var data = res;
      var expStmt = res.expStmt;
      var expStmtDetails = res.expStmtDetails;
      console.log('expStmt', expStmt);
      console.log('expStmtDetails', expStmtDetails);
      // console.log('expDetails ..', data);
      var arr: any;
      var data1: any = {};
      var arr2: any = [];
      expStmt.filter((el, index) => {
        data1 = el;
        arr = [];
        // debugger
        expStmtDetails.filter(data => {
          if (el.Client_Code === data.Client_Code) {
            arr.push(data);
          }
        })
        data1.details = arr;
        //   expStmt[index].details = arr;
        arr2.push(data1);
      })

      this.expDetails = arr2;

      console.log('arr2', arr2);

      this.staff = '';
      this.designation = '';
      this.currentMonth = this.currentDate
    })

    console.log('filterData ', queryData);
  }

}
